const STYLE_DATA = [
  {
    label: 'Rustic',
    value: 'style-rustic',
  },
  {
    label: 'Beachy',
    value: 'style-coastal-nautical',
  },
  {
    label: 'Glamorous',
    value: 'style-glamorous',
  },
  {
    label: 'Modern',
    value: 'style-modern',
  },
  {
    label: 'Bohemian',
    value: 'style-boho',
  },
  {
    label: 'Classic',
    value: 'style-classic',
  },
  {
    label: 'Vintage',
    value: 'style-vintage',
  },
  {
    label: 'Whimsical',
    value: 'style-offbeat-alternative',
  },
  {
    label: 'Romantic',
    value: 'style-romantic',
  },
  {
    label: 'Natural',
    value: 'style-natural',
  },
  {
    label: 'Botanical',
    value: 'style-outdoor',
  },
  {
    label: 'Industrial',
    value: 'style-urban-industrial',
  },
] as const;

export default STYLE_DATA;
